import {isNullOrUndefined} from "../../../services/Validator";

export default function DetailedGameLevelItem({level, isFirst, selectedLevel, setSelectedLevel}) {
    // Used in DetailedGameScreenContent to

    // BUILD
    if (isNullOrUndefined(level))
        return null
    return (
        <div onClick={() => setSelectedLevel(level)}
             className={`${!isFirst ? "mt-[16px]" : ""} bg-backgroundLight5 w-full flex flex-col space-y-[4px] px-[12px] py-[6px] rounded-[12px] border-[1px] ${renderItemStyle()}`}>
            <div className={"w-full flex justify-between items-center"}>
                <span className="font-normal text-greyLight7 text-[14px]">
                    {!isNullOrUndefined(level?.id) ? "Niveau " + level.id : ""}
                </span>
                <span className={"font-semibold text-greyLight9 text-[14px]"}>
                    {level?.grade ?? ""}
                </span>
            </div>
            <div className="flex flex-col justify-start items-start text-[16px]">
                <span className="font-semibold truncate">
                    {level.label ?? ""}
                </span>
                <p className="text-[16px] text-greyLight7">
                    {level.description ?? ""}
                </p>
            </div>
        </div>
    );

    // METHODS
    // ---- UI : Render item style
    function renderItemStyle() {
        return isLevelSelected()
            ? "cursor-default border-primaryLight1"
            : "cursor-pointer border-greyLight5 hover:border-primaryLight1";
    }

    // ---- LOGIC : Is current level selected
    function isLevelSelected() {
        if (level !== null && selectedLevel !== null) {
            return level.label === selectedLevel.label
        } else {
            return false
        }
    }
}